// extracted by mini-css-extract-plugin
module.exports =  {"filter":"J8hazkMxbAIO6_UxiQj5"};